module.exports = __webpack_public_path__ + "img/lachsbowloben.4e21da91.png";